import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Parallax } from 'react-scroll-parallax';
import { FiChevronRight } from 'react-icons/fi';

import SEO from '../components/seo';
import productHeroImg from '../images/product-page_hero.jpg';
import purpleBubble from '../images/purple-circle.svg';
import circle from '../images/circle.svg';
import blueCircle from '../images/blue-circle.svg';
import step1 from '../images/step1.svg';
import step2 from '../images/step2.svg';
import step3 from '../images/step3.svg';
import organize from '../images/organize_content.svg';
import share from '../images/share.png';
import findStuff from '../images/find_stuff.svg';
import newCommands from '../images/new-commands.svg';
import arrow1 from '../images/arrow1.svg';
import arrow2 from '../images/arrow2.svg';
import arrow3 from '../images/arrow3.svg';

import ios from '../images/ios.svg';
import web from '../images/web.svg';
import email from '../images/email.svg';
import createASystem from '../images/create-a-system.svg';
import stayOnTrack from '../images/stay-on-track.svg';

import report from '../images/report.svg';
import controlWork from '../images/control-work.svg';
// import mission_control1 from '../images/mission_control1.png';
// import mission_control2 from '../images/mission_control2.png';
// import softwareStack from '../images/stack.svg';

import '../styles/product.scss';

const ProductPage = () => (
  <>
    <SEO
      title="Product"
      description="Charli is the easiest way to get your “stuff” organized in to Google Drive"
      image={productHeroImg}
    />

    <Container fluid className="section-banner">
      <Row>
        <Col md="12" lg="5">
          <h1 className="page-header">
            Get organized.
            <br />
            Feel the zen.
          </h1>
          <p>
            Charli is the easiest way to organize and manage your content in one
            place.
          </p>
          <div className="button-teal short">
            <a
              href="https://charliai.typeform.com/to/IhzcZhjI"
              target="_blank"
              rel="noreferrer"
            >
              Request Access
            </a>
          </div>
        </Col>
        <Col md="12" lg="7">
          <div className="product-banner-thumbnail">
            <img
              className="product-hero-img"
              src={productHeroImg}
              alt="charli-ai"
            />

            <div className="product-conversation">
              <div className="userchat chat-1">
                <p>Charli, show me all my #tax content for 2020</p>
              </div>
              <div className="charlichat chat-i">
                <p>I’m looking into this right away, be right back.</p>
              </div>
              <div className="charlichat chat-ii">
                <p>
                  <img className="report-icon" src={report} alt="charli-ai" />
                  View Tax Content 2020 <FiChevronRight />
                </p>
              </div>
              <div className="userchat chat-2">
                <p>Thanks Charli!</p>
              </div>
            </div>
          </div>
          <Parallax className="circle wow" y={[20, -100]} tagOuter="figure">
            <img src={circle} data-wow-delay="0.5s" alt="charli-ai" />
          </Parallax>
          <Parallax className="purple-dot wow" y={[20, -200]} tagOuter="figure">
            <img src={purpleBubble} alt="charli-ai" />
          </Parallax>
        </Col>
      </Row>
    </Container>
    <Container fluid className="section-product-interaction">
      <Container>
        <Row>
          <Col sm="12" md="12" className="homepage-fluid-content--title">
            <h2>
              Like an assistant that organizes everything and
              <br />
              <span>
                gets $%^& done.
                <i className="underline wow" />
              </span>
            </h2>
            <p>
              Tame that inbox, clean up your desktop and find things faster.
              Charli is your ‘chief of stuff,’ helping you organize, find and
              share your stuff using a powerful combination of Natural Language
              + AI + Commands.
            </p>
          </Col>
        </Row>
        <Row>
          <Col md="12" className="product-mobile-container">
            <div className="note1">
              <img
                className="wow"
                data-wow-delay="0.25s"
                src={organize}
                alt="charli-ai"
              />
              <h4 className="wow" data-wow-delay="1.5s">
                Organize content
              </h4>
              <p>
                Charli uses AI magic to understand your content and automate
                organization. Add tags and notes to help Charli learn where to
                put stuff.
              </p>
            </div>
            <div className="note2-img">
              <img
                className="wow"
                data-wow-delay="1.5s"
                src={arrow1}
                alt="charli-ai"
              />
            </div>
            <div className="product-mobile-device wow">
              <div className="product-mobile-device__frame">
                <video
                  className="product-mobile-device__video"
                  src="https://pacemediafiles.s3-us-west-2.amazonaws.com/Charli-AI/charliAI-demo1.mp4"
                  autoPlay
                  playsInline
                  loop
                  muted
                  type="video/mp4"
                />
              </div>
            </div>
            <div className="note2 wow">
              <img
                className="wow"
                data-wow-delay="0.25s"
                src={findStuff}
                alt="charli-ai"
              />
              <h4 className="wow" data-wow-delay="2s">
                Find stuff faster
              </h4>
              <p>
                Charli makes finding stuff easier than ever. No more struggling
                with your inbox or cloud storage search, just ask Charli to find
                your content.
              </p>
              <img
                className="wow arrow2"
                data-wow-delay="2s"
                src={arrow2}
                alt="charli-ai"
              />
            </div>
            <div className="note3">
              <img
                className="wow"
                data-wow-delay="0.25s"
                src={share}
                alt="charli-ai"
              />
              <h4 className="wow" data-wow-delay="3.5s">
                Share and collaborate
              </h4>
              <p>
                Charli streamlines sharing while keeping track of who has access
                to your documents. Ask Charli to share stuff with your contacts
                and groups.
              </p>
              <img
                className="arrow3 wow"
                data-wow-delay="3.5s"
                src={arrow3}
                alt="charli-ai"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </Container>

    <Container fluid className="section-how-it-works">
      <Container>
        <Row>
          <Col sm="12" md="12" className="homepage-fluid-content--title">
            <h2>
              If you can chat, you can use
              <span>
                Charli.
                <i className="underline wow" />
              </span>
            </h2>
            <h3>How it works</h3>
          </Col>
        </Row>
        <Row className="how-it-works--container">
          <Col md="4" sm="12" className="how-it-works--step">
            <img className="wow" src={step1} alt="charli-ai" />
            <div className="how-it-works--content wow" data-wow-delay="1s">
              <span>1.</span>
              <p>
                Send your ‘stuff’ to Charli—just text, upload, scan or email.
              </p>
            </div>
          </Col>
          <Col md="4" sm="12" className="how-it-works--step">
            <img className="wow" src={step2} alt="charli-ai" />
            <div className="how-it-works--content wow" data-wow-delay="1.5s">
              <span>2.</span>
              <p>Add #hashtags to help Charli learn how you label things.</p>
            </div>
          </Col>
          <Col md="4" sm="12" className="how-it-works--step">
            <img className="wow" src={step3} alt="charli-ai" />
            <div className="how-it-works--content wow" data-wow-delay="2s">
              <span>3.</span>
              <p>
                Voila! Files are organized and ready to be shared as links or
                reports.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row className="how-it-works--commands">
          <Col md="12" lg="6">
            <img src={newCommands} alt="charli-ai" />
          </Col>
          <Col md="12" lg="6">
            <h2>/Command line is back!</h2>
            <h3>
              Use commands to make it even easier to interact with Charli.
            </h3>
            <p>
              Use ‘/’ commands to quickly take action. Tell Charli where to
              store content, who to share it with, set reminders and more. All
              with one powerful command line.
            </p>
          </Col>
        </Row>
      </Container>
    </Container>

    <Container fluid className="product-page-platforms">
      <Container>
        <Row>
          <Col sm="12" md="12" className="homepage-fluid-content--title">
            <h2>
              Available anytime, any place,
              <span>
                any device.
                <i className="underline wow" />
              </span>
            </h2>
            <p>
              Charli is there wherever and whenever you need a task managed
              across all the channels you already use for work. Loop Charli in
              by email, mobile, web and chat—while you’re on the go or at your
              desk
            </p>
          </Col>
        </Row>
        <Row className="product-page-platforms--container">
          <Col
            lg="4"
            md="12"
            className="platforms-wrapper wow"
            data-wow-delay="1s"
          >
            <h4>iOS</h4>
            <img src={ios} alt="charli-ai" />
          </Col>
          <Col
            lg="4"
            md="12"
            className="platforms-wrapper wow"
            data-wow-delay="1.5s"
          >
            <h4>Web</h4>
            <img src={web} alt="charli-ai" />
          </Col>
          <Col
            lg="4"
            md="12"
            className="platforms-wrapper wow"
            data-wow-delay="2s"
          >
            <h4>Email inbox</h4>
            <img src={email} alt="charli-ai" />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col sm="12" md="12" className="homepage-fluid-content--title">
            <h2>
              Stress less and get
              <span>
                more done.
                <i className="underline wow" />
              </span>
            </h2>
            <p>
              Whether you’re managing client files, incoming invoices, or
              collaborating with your team, save your precious time by letting
              Charli’s AI magic keep you on track. Charli will organize content,
              help you find stuff faster so you spend less time on admin.
            </p>
          </Col>
        </Row>
        <Row className="product-page-platforms--features">
          <Col md="12" lg="6">
            <h3>Create a system that works for you</h3>
            <p>
              Each new piece of content trains Charli to personalize
              organization to your preferences. Pretty quickly, you won&apos;t
              need to provide content clues or details, Charli&apos;s AI will
              just figure it out.
            </p>
          </Col>
          <Col
            md="12"
            lg="6"
            className="product-page-platforms--features-wrapper"
          >
            <img className="wow" src={createASystem} alt="charli-ai" />
            <div className="features-circle1">
              <img src={circle} data-wow-delay="0.5s" alt="charli-ai" />
            </div>
          </Col>
        </Row>

        <Row className="product-page-platforms--features">
          <Col
            md="12"
            lg="6"
            className="product-page-platforms--features-wrapper"
          >
            <img
              className="wow stay-on-track"
              src={stayOnTrack}
              alt="charli-ai"
            />
            <div className="features-circle2">
              <img src={blueCircle} data-wow-delay="0.5s" alt="charli-ai" />
            </div>
          </Col>
          <Col md="12" lg="6">
            <h3>Stay on track</h3>
            <p>
              Trust Charli to help you stay on top of things. When your content
              is organized you can more easily prioritize and focus on what
              matters. Charli makes it easier with proactive reminders and
              follow ups.
            </p>
          </Col>
        </Row>
      </Container>
    </Container>

    <Container fluid className="section-product-admin">
      <Row>
        <Col sm="12" md="12" className="homepage-fluid-content--title">
          <h2>
            Charli is mission control for your
            <span>
              workday.
              <i className="underline wow" />
            </span>
          </h2>
        </Col>
      </Row>
      <Row className="section-product-admin--wrapper">
        <Col md="12" lg="6" className="section-product-admin--graphic">
          <img src={controlWork} alt="charli-ai" />
        </Col>

        <Col md="12" lg="6" className="section-product-admin--content">
          <ul>
            <li>All your content in one place</li>
            <li>No hassle sharing and collaboration</li>
            <li>Organization personalized to your needs</li>
            <li>Simple yet powerful interface</li>
            <li>Works with your favorite apps </li>
          </ul>
        </Col>
      </Row>
    </Container>

    <Container fluid className="product-page-facts">
      <Container>
        <Row>
          <Col md="12" className="product-page-facts--content">
            <h3>
              Eliminating productivity killers for businesses, startups and
              connected workers everywhere.
            </h3>
            <h2>Did you know</h2>
            <p>
              <span className="pulse-data wow">60%</span> of office workers
              spend{' '}
              <span className="pulse-data wow" data-wow-delay="0.5s">
                3+
              </span>{' '}
              hours on admin per day.
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  </>
);

export default ProductPage;
